module.exports = __webpack_public_path__ + "static/media/logis3.546af74d.png";